import React, { createContext, useContext, useEffect } from 'react';
import { bridge } from './client-bridge.ts';
import { BridgeEvent, DTCMBridge } from './client-bridge-defs.ts';
import { useLocation } from 'react-router';

const BridgeContext = createContext<DTCMBridge>(bridge);

// Custom Hook to Access Bridge
export const useBridge = (): DTCMBridge => {
  const bridge = useContext(BridgeContext);
  if (!bridge) {
    throw new Error('useBridge must be used within a BridgeProvider');
  }
  return bridge;
};

export const BridgeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();

  useEffect(() => {
    handleNavigationChange(location);
  }, [location]);

  const handleNavigationChange = (
    newLocation: ReturnType<typeof useLocation>
  ) => {
    bridge.onEvent(BridgeEvent.NAVIGATION, {
      pathname: newLocation.pathname,
      search: newLocation.search,
      hash: newLocation.hash,
    });
  };

  return (
    <BridgeContext.Provider value={bridge}>{children}</BridgeContext.Provider>
  );
};
